import {
  setName,
  setPhone,
  setAnotherName,
  useAppDispatch,
  setAnotherPhone,
  setNoCallNeeded,
  setAnotherNoCallNeeded,
} from '@/app/store';
import { useCallback } from 'react';

export const useInputsChangePersonalInfo = (isOrderAnotherPerson?: boolean) => {
  const dispatch = useAppDispatch();

  const onNameChange = useCallback(
    (name: string) => {
      if (isOrderAnotherPerson) dispatch(setAnotherName(name));
      else dispatch(setName(name));
    },
    [dispatch, isOrderAnotherPerson],
  );

  const onPhoneChange = useCallback(
    (phone: string) => {
      if (isOrderAnotherPerson) dispatch(setAnotherPhone(phone));
      else dispatch(setPhone(phone));
    },
    [dispatch, isOrderAnotherPerson],
  );

  const onNoCallNeededChange = useCallback(
    (noCallNeeded: boolean) => {
      if (isOrderAnotherPerson) dispatch(setAnotherNoCallNeeded(noCallNeeded));
      else dispatch(setNoCallNeeded(noCallNeeded));
    },
    [dispatch, isOrderAnotherPerson],
  );

  return { onNameChange, onPhoneChange, onNoCallNeededChange };
};
